import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    i18nMomentPropType,
    localize,
} from 'wanderu-i18n';
import {
    generateFakeOnChangeEvent,
} from 'wanderu-utils';

import styles from './Day.scss';

const Day = function(props) {
    const {
        deemphasize,
        disabled,
        highlighted,
        isToday,
        date,
        onClick,
        data,
        highlightClass,
        i18nMoment,
    } = props;

    function _onClick(e) {
        if (disabled) {
            return;
        }

        const fakeOnChange = generateFakeOnChangeEvent(e, date);
        onClick(fakeOnChange);
    }

    function _renderData() {
        if (!data) {
            return (
                <div className={styles.data} />
            );
        }

        return (
            <div className={`${styles.data} ${data.className}`}>
                {data.text}
            </div>
        );
    }

    const dayNumber = i18nMoment(date).format('D');

    return (
        <td
            aria-label={`${dayNumber}-${disabled
                ? 'disabled'
                : 'active'}`}
            className={classNames(
                styles.day,
                {
                    [highlightClass]: highlighted,
                    [styles.disabled]: disabled,
                    [styles.deemphasize]: !highlighted && deemphasize,
                    [styles.today]: isToday,
                },
            )}
            onClick={_onClick}
        >
            <div className={styles.dayContainer}>
                <div className={styles.dayNumber}>
                    {dayNumber}
                </div>
                {_renderData()}
            </div>
        </td>
    );
};

Day.propTypes = {
    date: i18nMomentPropType,
    deemphasize: PropTypes.bool,
    disabled: PropTypes.bool,
    highlighted: PropTypes.bool,
    isToday: PropTypes.bool,
    onClick: PropTypes.func,
    highlightClass: PropTypes.string,
    data: PropTypes.shape({
        text: PropTypes.string,
        className: PropTypes.string,
    }),
};

export { Day };
export default localize(Day);
